export default __webpack_public_path__ + "static/media/ImageOther.2538145d.png";